(ns app.front.view.contractor-registration.subs
  (:require [app.domain.contractor-registration.model :as cr-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.view.workspace.primary-actions :as primary-actions]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-contractor-registration
  (fn [{:keys [db]} [_ cr-id]]
    {:db           (assoc db ::state {})
     :comm/command {:command    :contractor-registration/get
                    :method     :get
                    :data       (util/mmap cr-id)
                    :on-success [::fetch-contractor-registration.success cr-id]
                    :on-done    [::fetch-contractor-registration.error]}}))

(rf/reg-event-fx ::fetch-contractor-registration.success
  (fn [{:keys [db]} [_ cr-id status {:keys [entities unfinished-import-session-id]}]]
    {:db (-> db
             (assoc-in [::state :contractor-registration-id] cr-id)
             (assoc-in [::state :unfinished-import-session-id] unfinished-import-session-id)
             (p/dissoc-in [::state :not-found?]))
     :fx [[:dispatch [::entities/merge-entity-db status entities]]
          [:dispatch [::process/fetch-process-states-for-one
                      :entity.type/contractor-registration
                      nil
                      :permit-type/CR]]]}))

(rf/reg-event-db ::fetch-contractor-registration.error
  (fn [db _]
    (assoc-in db [::state :not-found?] true)))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::contractor-registration-id
  :<- [::state]
  :-> :contractor-registration-id)

(rf/reg-sub ::current-entity-process
  :<- [::contractor-registration-entity-id]
  (fn [cr-id _]
    (<sub [::process/generic-entity-process
           ;; country is selected based on the environment - this will not work if a single
           ;; environment handles multiple countries. But so far the contractor registration
           ;; entity has no unambiguous link to a countr and a single environment only deals
           ;; with a single country
           nil
           :permit-type/CR
           nil
           cr-id])))

(rf/reg-sub ::not-found?
  :<- [::state]
  :-> :not-found?)

(rf/reg-sub ::contractor-registration
  :<- [::entities/context]
  :<- [::contractor-registration-id]
  (fn [[ctx cr-id] _]
    (when cr-id
      (entities/find-entity ctx {:contractor-registration/id cr-id}))))

(rf/reg-sub ::contractor-registration-entity-id
  :<- [::contractor-registration]
  :-> :db/id)

(rf/reg-sub ::registration-trades
  :<- [::contractor-registration]
  :-> cr-model/contractor-registration-trades)

(rf/reg-sub ::registration-trade-names-sorted
  :<- [::registration-trades]
  :<- [:language]
  (fn [[trades lang] _]
    (->> trades
         (map #(-> %
                   :registered-trade/work-type
                   (config-model/localized-name lang)))
         sort)))

(rf/reg-sub ::authority-group
  :<- [::contractor-registration]
  :-> :domain/authority-group)

(rf/reg-sub ::tr-replacements
  :<- [::authority-group]
  (fn [authority-group _]
    (merge (group-model/get-i18n-mapping authority-group)
           (i18n-model/permit-type-specific-keys :permit-type/CR))))

(rf/reg-sub ::tr
  :<- [::tr-replacements]
  :<- [:tr]
  (fn [[replacements tr] _]
    (i18n-model/wrap-tr-fn replacements tr)))

(rf/reg-sub ::authority-group-id
  :<- [::authority-group]
  :-> :db/id)

(rf/reg-sub ::unfinished-import-session-id
  :<- [::state]
  :-> :unfinished-import-session-id)

(rf/reg-sub ::import-session-href
  :<- [::authority-group-id]
  :<- [::unfinished-import-session-id]
  (fn [[group-id session-id] _]
    (when session-id
      (href/href :view/group.admin.import.session
                 (util/mmap group-id session-id)))))

(rf/reg-sub ::options
  :<- [::tr]
  (fn [tr _]
    (let [process        (<sub [::current-entity-process])
          process-target (<sub [::contractor-registration-entity-id])]
      {:items (->> (primary-actions/secondary-actions (util/mmap tr process process-target))
                   (map (partial primary-actions/signal->action tr process-target)))})))

(rf/reg-sub ::view-data
  :<- [::import-session-href]
  :<- [::options]
  (fn [[import-session-href options] _]
    {:options   options
     :back-href (or import-session-href (href/href :dashboard))}))

(rf/reg-sub ::trades-with-removed-work-type
  :<- [::registration-trades]
  :<- [:language]
  (fn [[trades lang] _]
    (->> trades
         (filter #(config-model/soft-removed? (:registered-trade/work-type %)))
         (map #(-> %
                   :registered-trade/work-type
                   (config-model/localized-name lang))))))
